// Getters (GET*)
export const GET_LOGGED_USER = 'GET_LOGGED_USER';
export const GET_LOGGED_USER_FUNCTIONALITIES = 'GET_LOGGED_USER_FUNCTIONALITIES';

// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
export const CREATE_LOGGED_USER = 'CREATE_LOGGED_USER';
export const FETCH_USER_PROFILES_FUNCTIONALITIES = 'FETCH_USER_PROFILES_FUNCTIONALITIES';

// Mutations (SET*, ADD*, REMOVE*)
export const SET_LOGGED_USER = 'SET_LOGGED_USER';
